import { CommonModule } from '@angular/common';
import {
ChangeDetectionStrategy,
Component,
EventEmitter,
Inject,
Input,
OnDestroy,
Optional,
Output
} from '@angular/core';
import { FormArray,FormControl,FormGroup,ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {
MatLegacyDialogConfig as MatDialogConfig,MatLegacyDialogModule,MAT_LEGACY_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment,{ Moment } from 'moment';
import { BehaviorSubject,Subscription } from 'rxjs';
import { CalculationInputComponent } from '../../../../calculation-input/calculation-input.component';
import {
    AccountsReceivableLedgerEntity,
    financialRound,
QUANTITY_MAX_DECIMAL_PLACES
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../../helper/helper';
import { arlQuantityHistoryFormGroup } from '../arl-form-data.service';

export type QuantityHistoryModalComponentDialogReturnData = undefined;
export interface QuantityHistoryModalComponentDialogData {
    quantityHistoryForm: FormArray<arlQuantityHistoryFormGroup>;
}
@Component({
    selector: 'app-quantity-history-modal',
    templateUrl: './quantity-history-modal.component.html',
    styleUrls: ['./quantity-history-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, MatLegacyDialogModule, MatLegacyFormFieldModule, ReactiveFormsModule, MatLegacyInputModule, MatDatepickerModule, AppButtonModule, MatLegacyButtonModule, FontAwesomeModule, CalculationInputComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityHistoryModalComponent implements OnDestroy {
    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '400px',
    };
    protected _quantityHistoryForm: FormArray<arlQuantityHistoryFormGroup>;
    private valueChangesSub: Subscription | undefined;
    protected quantity$ = new BehaviorSubject<number | null>(null);
    @Input() set quantityHistoryForm(v: FormArray<arlQuantityHistoryFormGroup>) {
        this._quantityHistoryForm = v;
        this.updateQuantity();
        this.valueChangesSub?.unsubscribe();
        this.valueChangesSub = v.valueChanges.subscribe(() => {
            this.updateQuantity();
            this.quantityCalculated.emit(this.quantity$.value);
        });
    }
    @Output() quantityCalculated = new EventEmitter<number>();
    protected readonly showDialogHeadline: boolean | undefined;
    protected readonly showDialogActions: boolean | undefined;
    constructor(@Optional() @Inject(MAT_LEGACY_DIALOG_DATA) dialogData: QuantityHistoryModalComponentDialogData) {
        this.showDialogHeadline = !!dialogData;
        this.showDialogActions = !!dialogData;
        if (!!dialogData) {
            this.quantityHistoryForm = dialogData.quantityHistoryForm;
        }
    }

    ngOnDestroy(): void {
        this.valueChangesSub?.unsubscribe();
    }

    add() {
        this._quantityHistoryForm.push(
            new FormGroup({
                quantityDelta: new FormControl<number>(null),
                quantityDeltaFormula: new FormControl<string>(null),
                date: new FormControl<Moment>(moment(new Date())),
            }),
        );
    }

    remove(i: number) {
        this._quantityHistoryForm.removeAt(i);
    }

    updateQuantity() {
        const value = this._quantityHistoryForm.getRawValue().reduce((a, b) => financialRound(a + b.quantityDelta, QUANTITY_MAX_DECIMAL_PLACES), 0);
        this.quantity$.next(value);
    }

    protected readonly AccountsReceivableLedgerEntity = AccountsReceivableLedgerEntity;
}
